var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.404 20.5a.874.874 0 01-.644-.26.874.874 0 01-.26-.644v-1.733a1.8 1.8 0 01.527-1.275L16.69 3.931c.152-.138.319-.244.501-.319a1.5 1.5 0 01.575-.112c.2 0 .395.036.583.107.188.07.354.184.499.34l1.221 1.236c.155.145.266.311.332.5.066.188.099.377.099.565 0 .201-.034.393-.103.576-.069.183-.178.35-.328.501L7.412 19.973a1.8 1.8 0 01-1.276.527H4.404zM17.552 7.694L19 6.256 17.744 5l-1.438 1.448 1.246 1.246z",
    fill: "currentColor"
  })));
}
SvgEditFilled.displayName = 'EditFilled';
export default SvgEditFilled;